import Router from 'vue-router'
import Vue from 'vue'
import routes from '@/router'

import ChangePwd from './components/change_pwd.vue'
import Register from './components/register.vue'
import Login from './components/login.vue'
import Challenge from './components/challenge.vue'
import News from './components/news.vue'
import Home from './components/home.vue'
import Profile from './components/profile.vue'
import Rank from './components/rank.vue'
import Trend from './components/trend.vue'
import Team from './components/team.vue'
import Challenge_info from './components/challenge_info'

Vue.use(Router)

const replaceComponent = (key, component) => {
  routes.routes.forEach(route => {
    if (route.path === key) {
      route.component = component
    }
  })
}

const addPath = arr => {
  arr.forEach(route => {
    routes.routes.push(route)
  })
}

const replaceList = [
  {
    path: '/',
    component: Home
  },
  {
    path: '/profile',
    component: Profile
  },
  {
    path: '/news',
    component: News
  },
  {
    path: '/challenge',
    component: Challenge
  },
  {
    path: '/register',
    component: Register
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/changePwd',
    component: ChangePwd
  },
  {
    path: '/rank',
    component: Rank
  },
  {
    path: '/trend',
    component: Trend
  },
  {
    path: '/team/:tid',
    component: Team
  },
  {
    path: '/challenge/:pid',
    component: Challenge_info
  },
]

const addList = [
  {
    path: '/scoreboard',
    component: Rank
  },
  {
    path: '*',
    redirect: '/'
  }
]

replaceList.forEach(item => replaceComponent(item.path, item.component))

addPath(addList)

export default new Router(routes)



// WEBPACK FOOTER //
// ./src/themes/dragon/router.js